import { useCallback, useState } from 'react'
import { ButtonSecondary } from '../../../../../../baseComponents/Button'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { ModalOpenedTy } from '../../../../../../baseComponents/Modal/types'
import ModalSmallFilled from '../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'

interface CopyCategoryAddonsButtonProps extends CopyCategoryAddonsButtonLogicProps {}

const CopyCategoryAddonsButton: React.FC<CopyCategoryAddonsButtonProps> = ({...logic}) => {
    const {t} = useTwinTranslation()
    const { opened, setOpened, copyCategoryAddons, loading } = useCopyCategoryAddonsButtonLogic({ ...logic })
    return (
        <div>
            <ButtonSecondary onClick={() => setOpened(true)}>
                <TwinTrans transKey='copyAddons'>Copiar complementos</TwinTrans>
            </ButtonSecondary>
            {opened ?
                <ModalSmallFilled loading={loading} translations={{
                    title: t('sureCopyAddonsToProduct', '¿Seguro que quieres copiar los complementos al producto?'),
                    subtitle: t('willBecomeOnlyOfThisProduct', 'Se copiarán las propiedades pero ahora serán sólo de este producto'),
                    buttonAccept: t('accept', 'Acceptar')
                }} onAccept={copyCategoryAddons} opened={true} setOpened={() => setOpened(null)} />
                : null}
        </div>
    )
}


interface CopyCategoryAddonsButtonLogicProps {
    ProductId: number
    CategoryId: number
    getData: () => Promise<void>
    url: string
}

const useCopyCategoryAddonsButtonLogic = ({ ProductId, CategoryId, getData, url }: CopyCategoryAddonsButtonLogicProps) => {
    const [opened, setOpened] = useState<ModalOpenedTy>(null)
    const { startLoading, endLoading, loading } = useIsLoading()
    const copyCategoryAddons = useCallback(async () => {
        startLoading()
        const result = await twinFetchPostJSON(url, {
            ProductId,
            CategoryId
        })
        if (result) {
            setOpened(null)
            getData?.()
        }
        endLoading()
    }, [startLoading, endLoading, ProductId, CategoryId, getData, url])
    
    return { opened, setOpened, copyCategoryAddons, loading }
}

export default CopyCategoryAddonsButton